<template>
  <EnunciadoDemandasFormPesquisa />
  <div>
    <q-table
      class="fit"
      :columns="columns.map(column => ({ ...column, align: 'left' }))"
      row-key="id"
      :rows="rows"
      @row-click="(evt, row) => $router.push(`/sumula/${row.numero}`)"
      @request="request"
      v-model:pagination="_pagination"
    >
      <template v-slot:body-cell-acoes="enunciado">
        <q-td :props="enunciado">
          <q-btn
            flat
            icon="delete_outline"
            title="Excluir Súmula"
            @click.stop="deleteEnunciado(enunciado.row.numero)"
            v-if="admin"
          />
        </q-td>
      </template>
    </q-table>
    <AppConfirmModal v-model="confirmThemeDeletion" question="Tem certeza de que deseja excluir a Súmula?" @ok="excluirEnunciado(idEnunciadoExcluir)" />
  </div>
</template>


<script setup>
import EnunciadoDemandasFormPesquisa from "@/components/enunciado-demandas-form-pesquisa.vue";
import AppConfirmModal from "@/components/app/AppConfirmModal.vue"
import { useEnunciadoSituacaoStore } from "@/store/enunciado-situacao-store";
import { defineProps, defineEmits, ref, computed } from "vue";
import { useUserStore } from "@/store/user-store";
const userStore = useUserStore();
const situacaoStore = useEnunciadoSituacaoStore();
situacaoStore.fetch();

const props = defineProps({
  rows: {},
  pagination: {},
  headers: {
    type: Array,
    default: Array.from([
      "pje",
      "enunciado",
      "situacao",
      "acoes"
    ])
  }
});


const emit = defineEmits(["del", "update:pagination", "request"]);
const request = v => emit("request", v);
const _pagination = computed({
  get: () => props.pagination,
  set: v => emit("update:pagination", v)
});

const admin = computed(() => userStore.admin);
const nomeSituacaoFromId = id =>
  situacaoStore.all.find(situacao => situacao.id == id)?.descricao;

const confirmThemeDeletion = ref(false);
const idEnunciadoExcluir = ref(0);
const deleteEnunciado = id => {
  idEnunciadoExcluir.value = id;
  confirmThemeDeletion.value = true;
};

const excluirEnunciado = id => emit("del", id);
const allcolumns = computed(()=>[
  {
    name: "pje",
    label: "Código",
    field: "numero"
  },
  {
    name: "enunciado",
    label: "Descrição",
    field: "texto",
    style: () => `overflow: hidden;text-overflow: ellipsis; max-width: 40vw; white-space: pre-wrap;`
  },
  {
    name: "situacao",
    label: "Situação",
    field: "idSituacaoEnunciado",
    format: id => `${nomeSituacaoFromId(id)}`
  },
  { name: "texto", label: "Texto", field: "texto" },
  userStore.admin? { name: "acoes", label: "Ações", field: "acoes" } : {}
]);

const columns = computed(() =>
  allcolumns.value.filter(c => props.headers.includes(c.name))
);
</script>
